import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { Login } from './components/Login';
import { CreatePassword } from './components/CreatePassword';
import { Inquiries } from './components/Inquiries';
import { Launchpad } from './components/Launchpad';
import { BroadcastEvent, createBroadcastService, CSRF_VERIFIABLE_EVENT_TYPES } from './services/broadcast/broadcastHelper';
import { checkCSRF } from './services/Login';
import { TermsOfUse } from './components/TermsOfUse';
import { EmailVerification } from './components/EmailVerification';
import { UserRegistration } from './components/UserRegistration';
import { AccountConfirmation } from './components/AccountConfirmation';
// Uncomment the 3 lines below to run locally:
// import '@fg/design-system/css/fg-design-system.min.css';
// import '@fg/design-system/theming/Generic-theme.css';
// import './styles/app.css';

require('@fg/design-system/css/fg-design-system.min.css');
require('@fg/design-system/theming/Generic-theme.css');

function App(customProps) {
  const nonce = customProps.cspNonce;
  const cache = createCache({
    key: 'nonce-for-design-system',
    nonce: nonce,
  });

  let resetPasswordPage = false;
  let helpPage = false;
  let launchpadPage = false;
  let termsOfUsePage = false;
  let emailVerificationPage = false;
  let userRegistrationPage = false;
  let accountConfirmation = false;
  const urlEndPoint = window.location.toString();
  if (urlEndPoint.indexOf('/resetPassword') !== -1) {
    resetPasswordPage = true;
  } else if (urlEndPoint.indexOf('/help') !== -1) {
    helpPage = true;
  } else if (urlEndPoint.indexOf('/launchpad') !== -1) {
    launchpadPage = true;
  } else if (urlEndPoint.indexOf('/termsofuse') !== -1) {
    termsOfUsePage = true;
  } else if (urlEndPoint.indexOf('/sru') !== -1) {
    emailVerificationPage = true;
  } else if (urlEndPoint.indexOf('/userRegistration') !== -1) {
    userRegistrationPage = true;
  } else if (urlEndPoint.indexOf('/accountConfirmation') !== -1) {
    accountConfirmation = true;
  }
  const loginPage = !resetPasswordPage && !helpPage && !launchpadPage && !termsOfUsePage && !emailVerificationPage && !userRegistrationPage && !accountConfirmation;

  const broadcastService = createBroadcastService();
  broadcastService.addEventListener((event: BroadcastEvent) => {
    if (CSRF_VERIFIABLE_EVENT_TYPES.includes(event.eventType)) {
      checkCSRF(customProps.csrfToken);
    }
  });

  return (
    <CacheProvider value={cache}>
      {loginPage && <Login customProps={customProps} broadcastService={broadcastService} />}
      {resetPasswordPage && <CreatePassword customProps={customProps} />}
      {helpPage && <Inquiries customProps={customProps} />}
      {launchpadPage && <Launchpad customProps={customProps} broadcastService={broadcastService} />}
      {termsOfUsePage && <TermsOfUse customProps={customProps} />}
      {emailVerificationPage && <EmailVerification customProps={customProps} />}
      {userRegistrationPage && <UserRegistration customProps={customProps} />}
      {accountConfirmation && <AccountConfirmation customProps={customProps} />}
    </CacheProvider>
  );
}
export default App;